import React from "react";
import { PageWrapper, Main, Aside } from "./Page.styled";

function Page(props) {
  return (
    <PageWrapper>
      <Main>{props.children[0]}</Main>
      <Aside>{props.children[1]}</Aside>
    </PageWrapper>
  );
}

export default Page;
